import { HeaderMenu } from '@/components/header-menu';
import styles from './settings.module.scss';
import { SettingsList } from '@/components/settings-list';
import { Container } from '@/ui-kit';
import { useTranslation } from 'react-i18next';

export const Settings = () => {
    const { t } = useTranslation();
    
    return (
        <div className={styles.settings}>
            <HeaderMenu title={t('profile.settings')} marginBottom={20} />
            <Container>
                <SettingsList />
            </Container>
        </div>
    );
};
